import {decomposeColor, hslToRgb, rgbToHex} from '@mui/material/styles'

interface IHsl {
	// 0 to 360.
	hue: number,
	// 0 to 1.
	saturation: number,
	lightness: number,
}

export const toHsl = (color: string): IHsl => {
	const [r, g, b] = decomposeColor(color).values.slice(0, 3).map((value) => value / 255)
	const max = Math.max(r, g, b)
	const min = Math.min(r, g, b)
	const lightness = (max + min) / 2
	const delta = max - min
	if (delta === 0) return {hue: 0, saturation: 0, lightness}

	const saturation = delta / (1 - Math.abs(2 * lightness - 1))
	const sector = max === r ? ((g - b) / delta) % 6 : max === g ? (b - r) / delta + 2 : (r - g) / delta + 4
	return {hue: (sector * 60 + 360) % 360, saturation, lightness}
}

export const fromHsl = ({hue, saturation, lightness}: IHsl) =>
	rgbToHex(hslToRgb(`hsl(${((hue % 360) + 360) % 360}, ${saturation * 100}%, ${lightness * 100}%)`))
